import { UPDATE_CODES_INFO } from "../constants/codesInfo";
import { emptyCodesInfoState } from "../models/codesInfo";

import type { CodesInfoActions } from "../actions/codesInfo";
import type { CodesInfo } from "../models/codesInfo";

export function codesInfoReducer(
  state: CodesInfo = emptyCodesInfoState(),
  action: CodesInfoActions,
): CodesInfo {
  switch (action.type) {
    case UPDATE_CODES_INFO:
      return { ...state, ...action.codesInfo };
    default:
      return state;
  }
}
